import React from 'react';
import { useNavigate } from 'react-router';
import {
  Button,
  Gutter,
  Form,
  Input,
  Modal,
  ModalHeader,
  ModalSection,
  ModalFooter,
} from '@axiom/ui';
import type {
  TalentSearchResponse,
  TalentSearchDisplayFilters,
} from '@axiom/validation';
import { TalentSearchDisplayFiltersSchema } from '@axiom/validation';

import { TalentSearchFilters } from '../TalentSearchFilters/TalentSearchFilters';
import { WindowUtil } from '../../utils/window-util';
import { CandidateApi } from '../../api/candidate-api';
import { TalentSearchFilterUtil } from '../../utils/talent-search-filter-util';

export interface TalentSearchFilterSidedrawerProps {
  disabled?: boolean;
  searchResponse: TalentSearchResponse;
  displayFilters: TalentSearchDisplayFilters;
  onClose: () => void;
}

export const TalentSearchFilterSidedrawer = ({
  disabled,
  searchResponse,
  displayFilters,
  onClose,
}: TalentSearchFilterSidedrawerProps) => {
  const navigate = useNavigate();

  return (
    <Modal size="large">
      <ModalHeader
        name="TALENT_SEARCH_MOBILE_FILTERS_SIDEDRAWER_HEADER"
        onClose={() => {
          onClose();
        }}
      >
        Filters
      </ModalHeader>
      <ModalSection>
        <Form
          key={JSON.stringify(displayFilters)}
          name="TALENT_SEARCH_MOBILE_FILTERS_FORM"
          schema={TalentSearchDisplayFiltersSchema}
          initialValues={{
            search: displayFilters.search,
            categories: displayFilters.categories,
            sort: displayFilters.sort,
            hasSearched: displayFilters.hasSearched,
          }}
          submitOnChange
          onSubmit={async (_, __, formData) => {
            const { data, isUnderQueryLimit } =
              TalentSearchFilterUtil.getSelectedFilters(formData);
            if (isUnderQueryLimit) {
              void navigate('/browse-talent/page/1');
              WindowUtil.setUrlQuery(data, true);
              await CandidateApi.refreshCandidateSearchResults();
            }
          }}
        >
          {({ values }) => {
            return (
              <>
                <Input
                  name="search"
                  placeholder="Search"
                  disabled={disabled}
                  icon="search"
                />
                <Gutter bottom="16px" />
                <TalentSearchFilters
                  formData={values as TalentSearchDisplayFilters}
                  disabled={disabled}
                />
              </>
            );
          }}
        </Form>
      </ModalSection>
      <ModalFooter>
        <Button
          name="TALENT_SEARCH_MOBILE_FILTERS_CLEAR_ALL"
          variation="outline"
          onClick={async () => {
            WindowUtil.setUrlQuery({}, true);
            await CandidateApi.refreshCandidateSearchResults();
            void navigate('/browse-talent/page/1');
          }}
        >
          Clear All
        </Button>
        <Button
          name="TALENT_SEARCH_MOBILE_FILTERS_SHOW"
          onClick={() => {
            onClose();
          }}
        >
          Show {searchResponse.meta.resultCount}
        </Button>
      </ModalFooter>
    </Modal>
  );
};
